import React, {useEffect, useState} from "react";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import BasicAlert from "../../Components/Alerts/BasicAlert";

export default function () {
    const [data, setData] = useState({
        title: "",
        region: "",
        regionAll: "",
        description: ""
    });
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        const baseUrl = process.env.REACT_APP_API_URL;
        axios.get(`${baseUrl}delivery-templates`)
            .then((res) => {
                setData(res.data);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    const handleSubmit = async () => {
        const baseUrl = process.env.REACT_APP_API_URL;
        try {
            await axios.post(`${baseUrl}delivery-templates`, {
                title: data.title,
                region: data.region,
                regionAll: data.regionAll,
                description: data.description
            });
            setAlert({
                title: "Success",
                body: "Data submitted successfully!",
                alertClass: "alert alert-success"
            });
            setTimeout(() => setAlert(null), 3000);
        } catch (err) {
            console.error("Error submitting data:", err);
            setAlert({
                title: "Error",
                body: "Failed to submit data. Please try again.",
                alertClass: "alert alert-danger"
            });
            setTimeout(() => setAlert(null), 3000);
        }
    };

    return (
        <Card title="Delivery Information">
            {alert && <BasicAlert {...alert} />}
            <div className="col-xxl-12 pt-5">
                <div className="card card-flush py-4 flex-row-fluid">
                    <div className="card-header">
                        <div className="card-title">
                            <div>
                                <b>Title</b>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    value={data?.title || ""}
                                    onChange={(e) =>
                                        setData({...data, title: e.target.value})
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-0">
                        {data ? (
                            <>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control mb-2"
                                        value={data.region || ""}
                                        onChange={(e) =>
                                            setData({...data, region: e.target.value})
                                        }
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control mb-2"
                                        value={data.regionAll || ""}
                                        onChange={(e) =>
                                            setData({...data, regionAll: e.target.value})
                                        }
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        className="form-control mb-2"
                                        value={data.description || ""}
                                        onChange={(e) =>
                                            setData({...data, description: e.target.value})
                                        }
                                    />
                                </div>
                            </>
                        ) : (
                            <div>Loading...</div>
                        )}
                    </div>

                    <div className="card-footer pt-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </Card>
    );
}
